import { MyTicketsTabHeader } from './MyTicketsTabHeader/MyTicketsTabHeader';
import {
  TableWrapper,
  Table,
  NoFiltersMatchIcon,
  NoTicketsIcon,
  LayoutWrapper,
  HeaderWrapper,
  FooterWrapper,
} from './MyTicketsDesktop.styled';
import { TableHead } from './MyTicketsTable/TableHead/TableHead';
import { TableBody } from './MyTicketsTable/TableBody/TableBody';
import { EmptyTableBody } from '../../common/EmptyTableBody/EmptyTableBody';
import { MyTicketsTabFooter } from './MyTicketsTabFooter/MyTicketsTabFooter';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { TicketsAddPopup } from '../../common/TicketsAddPopup/TicketsAddPopup';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';
import { OptionSet } from 'src/components/Tickets/models/Tickets.interface';
import { useGetTicketTypes } from '../../hooks/useGetTicketTypes';
import { useGetTicketApprovalStatuses } from '../../hooks/useGetTicketApprovalStatuses';
import { useGetTicketPriorities } from '../../hooks/useGetTicketPriorities';
import { useGetTicketCategories } from '../../hooks/useGetTicketCategories';
import { useCreateTicket } from '../../hooks/useCreateTicket';
import { Alert } from 'src/components/common/AlertMessage/AlertMessage';
import { TicketDetailsPopup } from 'src/components/Tickets/components/desktop/TicketDetailsPopup/TicketDetailsPopup';

export const MyTicketsDesktop = () => {
  const {
    ticketsDataModified,
    emptyState,
    loadingTickets,
    handleSubmittedTicket,
    addTicketPopup,
    isSelectedFilter,
    viewTicketDetailsPopup,
  } = useServiceDeskContext();

  const { ticketTypes, isLoadingTicketTypes } = useGetTicketTypes();
  const { ticketApprovalStatuses, isLoadingTicketApprovalStatuses } =
    useGetTicketApprovalStatuses();
  const { ticketPriorities, isLoadingTicketPriorities } =
    useGetTicketPriorities();
  const { ticketCategories, isLoadingTicketCategories } =
    useGetTicketCategories();
  const {
    createTicket,
    isLoadingCreateTicket,
    hideAlert,
    requestStatusAppearance,
    requestStatusMessage,
  } = useCreateTicket();

  const parsedTicketCategories: OptionSet[] = ticketCategories?.map(
    (category) => {
      return {
        value: category.new_axsticketcategoryid,
        label: category.new_name,
      };
    }
  );

  if (
    loadingTickets ||
    isLoadingTicketTypes ||
    isLoadingTicketApprovalStatuses ||
    isLoadingTicketPriorities ||
    isLoadingTicketCategories
  ) {
    return (
      <>
        <MyTicketsTabHeader />
        <TableWrapper>
          <Table>
            <TableHead />
          </Table>
          <LoadingSpinner />
        </TableWrapper>
        {ticketsDataModified?.length > 0 && <MyTicketsTabFooter />}
      </>
    );
  }
  if (viewTicketDetailsPopup) {
    return <TicketDetailsPopup />;
  }

  return (
    <>
      {requestStatusMessage && (
        <Alert
          requestStatusAppearance={requestStatusAppearance}
          requestStatusMessage={requestStatusMessage}
          showCloseButton={true}
          overlay={true}
          handleClose={hideAlert}
        />
      )}
      {addTicketPopup && (
        <TicketsAddPopup
          ticketTypes={ticketTypes}
          ticketApprovalStatuses={ticketApprovalStatuses}
          ticketCategories={parsedTicketCategories}
          ticketPriorities={ticketPriorities}
          createTicket={createTicket}
          isLoadingCreateTicket={isLoadingCreateTicket}
          handleSubmittedTicket={handleSubmittedTicket}
        ></TicketsAddPopup>
      )}
      <LayoutWrapper>
        <HeaderWrapper>
          <MyTicketsTabHeader />
        </HeaderWrapper>
        <TableWrapper>
          <Table>
            <TableHead />
            <TableBody />
          </Table>
          {!ticketsDataModified && (
            <EmptyTableBody
              title={emptyState.noTickets.title}
              subtitle={emptyState.noTickets.subtitle}
              icon={<NoTicketsIcon />}
            />
          )}

          {ticketsDataModified &&
            ticketsDataModified.length === 0 &&
            (isSelectedFilter ? (
              <EmptyTableBody
                title={emptyState.noFilters.title}
                subtitle={emptyState.noFilters.subtitle}
                icon={<NoFiltersMatchIcon />}
              />
            ) : (
              <EmptyTableBody
                title={emptyState.noTickets.title}
                subtitle={emptyState.noTickets.subtitle}
                icon={<NoTicketsIcon />}
              />
            ))}
        </TableWrapper>
        <FooterWrapper>
          {ticketsDataModified?.length > 0 && <MyTicketsTabFooter />}
        </FooterWrapper>
      </LayoutWrapper>
    </>
  );
};
